define.alias("shared/components/shared/ui/mobile-redirect-prompt", "settings/components/shared/ui/mobile-redirect-prompt");